import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="onboarding"
export default class extends Controller {
  static targets = [
    "firstName",
    "lastName",
    "organizationName",
    "previewName",
    "previewOrganization",
    "previewInitials",
  ];
  static values = {
    profileImageUrl: String,
  };

  declare readonly firstNameTarget: HTMLInputElement;
  declare readonly lastNameTarget: HTMLInputElement;
  declare readonly organizationNameTarget: HTMLInputElement;
  declare readonly previewNameTarget: HTMLElement;
  declare readonly previewOrganizationTarget: HTMLElement;
  declare readonly previewInitialsTarget: HTMLElement;

  declare readonly hasPreviewInitialsTarget: boolean;

  declare profileImageUrlValue: string;

  connect(): void {
    this.updatePreview();
  }

  updatePreview(): void {
    const firstName = this.firstNameTarget.value.trim();
    const lastName = this.lastNameTarget.value.trim();
    const orgName = this.organizationNameTarget.value.trim();

    // Update name
    const fullName = [firstName, lastName].filter(Boolean).join(" ");
    this.previewNameTarget.textContent = fullName || "Your Name";

    // Update organization
    this.previewOrganizationTarget.textContent = orgName || "Personal";

    // Update initials (if no profile image)
    if (this.hasPreviewInitialsTarget && !this.profileImageUrlValue) {
      const initials = [firstName, lastName]
        .filter(Boolean)
        .map((n) => n.charAt(0).toUpperCase())
        .join("");
      this.previewInitialsTarget.textContent = initials || "?";
    }
  }

  // Called on input events
  onInput(): void {
    this.updatePreview();
  }
}
